import BaseApi from './base.api'
class SaleApi extends BaseApi {
  clipboardUrl = 'clipboards/'
  clipboardRowsUrl = 'clipboard-rows/'
  clipboardGroupsUrl = 'clipboard-groups/'
  documentsUrl = 'documents/'
  electronicInvoiceUrl = 'electronic-invoices/'
  documentRowsUrl = 'documents-rows/'
  saleReasonsUrl = 'sale-reasons/'

  constructor() {
    super('sale/')
  }

  batchDeleteSaleDocumentAsync = (ids) => this.post(`${this.documentsUrl}batch-delete/`, { ids })
  batchDeleteSaleDocumentRowsAsync = (ids) => this.post(`${this.documentRowsUrl}batch-delete/`, { ids })

  getClipboardsAsync = (params) => this.get(this.clipboardUrl, params)
  getClipboardGroupsAsync = (params) => this.get(this.clipboardGroupsUrl, params)
  createClipboardGroupAsync = (data) => this.post(this.clipboardGroupsUrl, data)
  deleteClipboardGroupAsync = (id) => this.delete(`${this.clipboardGroupsUrl}${id}`)
  updateClipboardRowAsync = (id, data) => this.patch(`${this.clipboardRowsUrl}${id}`, data)

  getDocumentByIdAsync = (documentId = null) => this.get(`${this.documentsUrl}${documentId || ''}`)
  getSaleDocumentDetailsAsync = (id, params, config = {}) => this.get(`${this.documentsUrl}${id}/details`, params, config)
  getDocumentRelationTreeAsync = (id, documentType) => this.get(`${this.documentsUrl}${id}/document-relation-tree/`, {document_type: documentType})

  getSaleDocumentNextIdByDataAsync = (data) => this.post(`${this.documentsUrl}next/`, data)

  reorderSaleDocumentRowsAsync = (documentId, data) => this.post(`${this.documentRowsUrl}${documentId}/reorder_row_numbers/`, data)

  getSaleReasonsAsync = () => this.get(this.saleReasonsUrl)

  generateSaleDocumentFromWorksheet = (data) => this.post(`${this.documentsUrl}generate-sale-document/`, data)

  updateElectronicInvoiceStatuses = (data, config = {}) => this.post(`${this.electronicInvoiceUrl}update-statuses/`, data, config)
  downloadElectronicInvoicesAsync = (data, fileName, config = {}) => this.download(`${this.electronicInvoiceUrl}download-electronic-invoice/`, fileName, null, false, { ...config, ...{ method: 'post', data: data } })
  getElectronicInvoiceChartDataAsync = (params) => this.get(`${this.electronicInvoiceUrl}chart-data/`, params)

  transmitElectronicInvoiceAsync = (data, config = {}) => this.post(`${this.electronicInvoiceUrl}transmit/`, data, config)

  updateExcludedSaleReasonsAsync = (data) => this.patch(`${this.saleReasonsUrl}update_excluded_sale_reasons/`, data)
  updateElectronicInvoiceStatusAsync = (id, params, config = {}) => this.patch(`${this.electronicInvoiceUrl}${id}/update-transmission-status/`, params, config)

  printSaleDocumentsAsync = (filename, data, config) => this.download(`${this.documentsUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  printPreviewSaleDocumentAsync = (data) => this.downloadBlob(`${this.documentsUrl}print/`, null, false, { method: 'post', data: data })

  saleDocumentReloadCustomerAsync = (id, data) => this.post(`${this.documentsUrl}${id}/reload-customer/`, data)
  saleDocumentReloadDeliveryAddressAsync = (id, data) => this.post(`${this.documentsUrl}${id}/reload-delivery-address/`, data)
}
export const saleApi = new SaleApi()
